var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"flex flex-center"},[_c('div',{staticClass:"sign-box"},[_c('payment-form',{ref:"paymentForm",attrs:{"total":_vm.cart.total,"process":_vm.process,"viewer-student":_vm.viewerStudent,"billing-name":_vm.billingName,"use-bank-transfer":""}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }